import React from 'react'
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Index.layout = (page) => <AppShell>{page}</AppShell>

const PURPOSE_LABELS = {
  hausgeld: 'Hausgeld',
  reserve: 'Rücklage',
  rent: 'Miete',
  deposit: 'Kaution',
}

export default function Index({ property, bank_accounts }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title="Bankkonten"
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Bankkonten' },
        ]}
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Kontoinhaber</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>IBAN</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Verwendungszweck</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Kontostand</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bank_accounts.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Bankkonten vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {bank_accounts.map((ba) => (
              <TableRow key={ba.id} hover sx={{ cursor: 'pointer' }}
                data-testid={`bank-account-row-${ba.id}`}
                onClick={() => router.visit(`${basePath}/bank_accounts/${ba.id}`)}
              >
                <TableCell>{ba.account_holder}</TableCell>
                <TableCell>{ba.iban}</TableCell>
                <TableCell>{PURPOSE_LABELS[ba.purpose] || ba.purpose || '—'}</TableCell>
                <TableCell align="right"><FormattedCurrency value={ba.current_balance} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
